import { CheckOutlined, DeleteOutlined, EditOutlined, PlusOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import { gql, useMutation } from "@apollo/client";
import { ActivityTemplatesQueryProvider } from "__legacy/queries/activities/ActivityTemplatesQueryProvider";
import { Button, Input, Layout, notification, PageHeader, Popconfirm, Row, Space, Table, Tabs, Tooltip } from "antd";
import { Fragment, useState } from "react";
import { NavLink, useNavigate, useParams } from "react-router-dom";

const deleteActivityTemplateMutation = gql`
  mutation($id: ID!) {
    deleteActivityTemplate(id: $id) {
      activityTemplate {
        id
        name
      }
    }
  }
`;

export const List: React.FC<{}> = () => {
  const { agencyId } = useParams();
  const navigate = useNavigate();
  const [activePane, setActivePane] = useState();

  const [searchQuery, setSearchQuery] = useState<string | null>(null);
  const handleSearch = (value: string) => setSearchQuery(value.trim());

  const [execDelete] = useMutation(deleteActivityTemplateMutation, {
    errorPolicy: "none",
    onError: (error) => {
      notification.error({
        message: error.message,
      });
    },
    onCompleted: ({ deleteActivityTemplate: { activityTemplate } }) => {
      notification.success({
        message: `Template "${activityTemplate.name}" deleted`,
      });
    },
    refetchQueries: ["ActivityTemplatesQuery"],
  });

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      render: (value: string, resource: any) => <NavLink to={`${resource.id}/edit`}>{value}</NavLink>,
    },
    {
      title: "Certification Kind",
      dataIndex: "kind",
      render: (value: string) => value.toUpperCase(),
    },
    {
      title: "Default",
      dataIndex: "isDefault",
      render: (value: string) => <span>{value && <CheckOutlined style={{ color: "#52c41a" }} />}</span>,
    },
    {
      width: "80px",
      title: "Actions",
      dataIndex: "id",
      render: (id: string) => (
        <Row justify="end">
          <Space>
            <Tooltip title="Edit" placement="bottom">
              <Button onClick={() => navigate(`${id}/edit`)} icon={<EditOutlined />}></Button>
            </Tooltip>
            <Popconfirm
              title="Are you sure?"
              icon={<QuestionCircleOutlined />}
              onConfirm={() => execDelete({ variables: { id } })}
            >
              <Tooltip title="Delete" placement="bottom">
                <Button danger icon={<DeleteOutlined />}></Button>
              </Tooltip>
            </Popconfirm>
          </Space>
        </Row>
      ),
    },
  ];

  return (
    <ActivityTemplatesQueryProvider variables={{ agencyId, kind: activePane, search: searchQuery }}>
      {({ activityTemplates }) => (
        <Fragment>
          <PageHeader
            ghost={true}
            title="Templates"
            extra={
              <Fragment>
                <Input.Search
                  allowClear
                  placeholder="search"
                  onSearch={handleSearch}
                  defaultValue={searchQuery ?? ""}
                  style={{ width: 500 }}
                />
                <Button onClick={() => navigate("new")} type="primary">
                  <PlusOutlined />
                  New
                </Button>
              </Fragment>
            }
            footer={
              <Tabs
                activeKey={activePane}
                onChange={(activeKey: any) => setActivePane(activeKey !== "all" ? activeKey : undefined)}
              >
                <Tabs.TabPane tab="All" key="all" />
                <Tabs.TabPane tab="Company" key="company" />
                <Tabs.TabPane tab="Product" key="product" />
                <Tabs.TabPane tab="Skill" key="skill" />
              </Tabs>
            }
          />
          <Layout.Content className="content">
            <Table rowKey="id" columns={columns} dataSource={activityTemplates} pagination={false} />
          </Layout.Content>
        </Fragment>
      )}
    </ActivityTemplatesQueryProvider>
  );
};
